/**
 * سیستم تم متمرکز — قرچک فکتوری (هماهنگ با re-skin بصری)
 * پالت‌آگاه: colorPrimary از پالت انتخابی می‌آید. توکن‌های antd با styles دیزاین هماهنگ.
 */
import { theme as antdTheme } from "antd";

// brand هر پالت (مطابق gharchak-theme.css / theme.jsx دیزاین)
export const PALETTE_BRAND = {
  navy:    { brand: "#1F4E79", light: "#2E74B5" },
  indigo:  { brand: "#2B43C4", light: "#5B7BF5" },
  emerald: { brand: "#0E6E52", light: "#13A37B" },
  slate:   { brand: "#3C4663", light: "#5B6CFF" },
};

// رنگ‌های معنایی (مطابق MODES.light دیزاین)
export const COLORS = {
  success: "#16794a",
  warning: "#b45309",
  info: "#0e7490",
  danger: "#b42318",
  gold: "#9a6a12",
};

export const RADIUS = 11;        // مطابق دکمه/ورودی دیزاین
export const RADIUS_LG = 16;     // مطابق کارت دیزاین

function sharedToken(brand) {
  return {
    colorPrimary: brand,
    colorSuccess: COLORS.success,
    colorWarning: COLORS.warning,
    colorInfo: COLORS.info,
    colorError: COLORS.danger,
    fontFamily: "'Peyda', Tahoma, Arial, sans-serif",
    borderRadius: RADIUS,
    fontSize: 14,
    sizeStep: 4,
    sizeUnit: 4,
    wireframe: false,
  };
}

const sharedComponents = {
  Card: { borderRadiusLG: RADIUS_LG, paddingLG: 22 },
  Table: { headerBorderRadius: 0, cellPaddingBlock: 13, cellPaddingInline: 16, fontSize: 14 },
  Statistic: { titleFontSize: 13, contentFontSize: 26 },
  Form: { itemMarginBottom: 16, verticalLabelPadding: "0 0 6px" },
  Tabs: { horizontalItemPadding: "10px 14px", horizontalMargin: "0 0 14px 0" },
  Button: { borderRadius: RADIUS, controlHeight: 38, fontWeight: 700, primaryShadow: "none" },
  Input: { borderRadius: RADIUS },
  Select: { borderRadius: RADIUS },
  Modal: { borderRadiusLG: RADIUS_LG },
  Segmented: { borderRadius: RADIUS },
};

export function getTheme(mode, palette = "navy") {
  const { brand } = PALETTE_BRAND[palette] || PALETTE_BRAND.navy;
  if (mode === "dark") {
    return {
      algorithm: antdTheme.darkAlgorithm,
      token: { ...sharedToken(brand), colorBgLayout: "#0d1117", colorBgContainer: "#161c26" },
      components: {
        ...sharedComponents,
        Card: { ...sharedComponents.Card, boxShadow: "0 6px 18px rgba(0,0,0,.45)" },
        Table: { ...sharedComponents.Table, headerBg: "#1c2430", headerColor: "#9aa6b8", rowHoverBg: "#212b39" },
      },
    };
  }
  return {
    algorithm: antdTheme.defaultAlgorithm,
    token: { ...sharedToken(brand), colorBgLayout: "#eef1f6", colorBgContainer: "#ffffff" },
    components: {
      ...sharedComponents,
      Card: { ...sharedComponents.Card, boxShadow: "0 1px 2px rgba(20,30,50,0.06)" },
      Table: { ...sharedComponents.Table, headerBg: "#f6f8fb", headerColor: "#5d6776", rowHoverBg: "#f0f5fc" },
    },
  };
}
